// Кнопка «Сгенерировать» внутри поля названия: сервер подбирает случайное свободное
// название (app/names.py в engine): команда не занята в соревновании, соревнование
// не повторяет мои в этой лиге.
import { useState } from "react";
import { suggestName, type NameTarget } from "@/api/queries";

export function GenerateName({
  target,
  onPick,
}: {
  target: NameTarget | null;
  onPick: (name: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      className="input-wrap__gen"
      disabled={!target || busy}
      title="Сгенерировать свободное название"
      aria-label="Сгенерировать название"
      onClick={async () => {
        if (!target) return;
        setBusy(true);
        try {
          onPick(await suggestName(target));
        } catch {
          // подсказка не обязательна: поле остаётся как было
        } finally {
          setBusy(false);
        }
      }}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className={busy ? "input-wrap__spin" : undefined}
      >
        <rect x="3" y="3" width="18" height="18" rx="4" />
        <circle cx="8" cy="8" r="1.3" fill="currentColor" />
        <circle cx="16" cy="8" r="1.3" fill="currentColor" />
        <circle cx="12" cy="12" r="1.3" fill="currentColor" />
        <circle cx="8" cy="16" r="1.3" fill="currentColor" />
        <circle cx="16" cy="16" r="1.3" fill="currentColor" />
      </svg>
      <span className="input-wrap__gen-text">Сгенерировать</span>
    </button>
  );
}
